if (!customElements.get('noeo-go-book-table')) {
  customElements.define('noeo-go-book-table', class extends HTMLElement {
    connectedCallback() {
      if (this.onCopy) return;
      this.onCopy = async (event) => {
        const button = event.target.closest('button[data-copy-text]');
        if (!button || !this.contains(button)) return;
        const text = button.dataset.copyText;
        const status = this.querySelector('[role="status"]');
        clearTimeout(this.statusTimer);
        status.textContent = '';
        this.querySelectorAll('[data-copy-state]').forEach((item) => item.removeAttribute('data-copy-state'));
        let copied = false;
        try {
          await navigator.clipboard.writeText(text);
          copied = true;
        } catch (_) {
          const field = document.createElement('textarea');
          field.value = text;
          field.style.cssText = 'position:fixed;left:-9999px;top:0;';
          field.setAttribute('readonly', '');
          this.append(field);
          field.select();
          try { copied = document.execCommand('copy'); } catch (_) { /* Show failure below. */ }
          field.remove();
          button.focus({ preventScroll: true });
        }
        status.textContent = copied ? 'Copied!' : 'Couldn’t copy automatically. Select the text to copy it.';
        button.dataset.copyState = copied ? 'Copied!' : 'Select to copy';
        this.statusTimer = setTimeout(() => { status.textContent = ''; button.removeAttribute('data-copy-state'); }, 2500);
      };
      this.addEventListener('click', this.onCopy);
    }
    disconnectedCallback() {
      clearTimeout(this.statusTimer);
      this.removeEventListener('click', this.onCopy);
      this.onCopy = null;
    }
  });
}

// Open native course-detail disclosures before following their in-page links.
if (!window.noeoGoDetailLinksBound) {
  window.noeoGoDetailLinksBound = true;
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href^="#noeo-go-"]');
    if (!link) return;
    const target = document.getElementById(link.getAttribute('href').slice(1));
    if (!target) return;
    const details = target.closest('details');
    if (details) details.open = true;
  });
}
